import { render, staticRenderFns } from "./TermsAutofill.vue?vue&type=template&id=50d2d63d&"
import script from "./TermsAutofill.vue?vue&type=script&lang=ts&"
export * from "./TermsAutofill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports